module.exports = __webpack_public_path__ + "static/media/icon-character__albert-camus.84d3ee70.svg";